export default {
      id: "table-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#table-usage",
      toString: function () {
        return this.url;
      }
    }